module.exports = __webpack_public_path__ + "static/the-4-mindsets-of-effective-leadership-c981cec22e6c421afb3c5cd749927618.png";